(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1171],{

/***/ 49715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97588);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const PC = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8096), __webpack_require__.e(5734), __webpack_require__.e(4176), __webpack_require__.e(2736), __webpack_require__.e(5728), __webpack_require__.e(3184), __webpack_require__.e(3219), __webpack_require__.e(7433), __webpack_require__.e(4091), __webpack_require__.e(6777), __webpack_require__.e(8131), __webpack_require__.e(2793), __webpack_require__.e(6225), __webpack_require__.e(4233), __webpack_require__.e(3233), __webpack_require__.e(2456), __webpack_require__.e(3651), __webpack_require__.e(8352), __webpack_require__.e(1331), __webpack_require__.e(1450), __webpack_require__.e(9642), __webpack_require__.e(8564), __webpack_require__.e(2403), __webpack_require__.e(8159), __webpack_require__.e(652), __webpack_require__.e(3336), __webpack_require__.e(6400), __webpack_require__.e(7842), __webpack_require__.e(2256), __webpack_require__.e(4805), __webpack_require__.e(4728), __webpack_require__.e(3601), __webpack_require__.e(3068), __webpack_require__.e(6189), __webpack_require__.e(1991), __webpack_require__.e(9583), __webpack_require__.e(6194), __webpack_require__.e(6601), __webpack_require__.e(85), __webpack_require__.e(303), __webpack_require__.e(4524), __webpack_require__.e(6169), __webpack_require__.e(6458), __webpack_require__.e(9685), __webpack_require__.e(1988), __webpack_require__.e(2271), __webpack_require__.e(4695), __webpack_require__.e(3456), __webpack_require__.e(3973), __webpack_require__.e(6390), __webpack_require__.e(8745), __webpack_require__.e(186), __webpack_require__.e(9399), __webpack_require__.e(3687), __webpack_require__.e(2378), __webpack_require__.e(4146)]).then(__webpack_require__.bind(__webpack_require__, 44146)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(44146)]
  }
});
const Mobile = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8096), __webpack_require__.e(5734), __webpack_require__.e(4176), __webpack_require__.e(6538), __webpack_require__.e(6167), __webpack_require__.e(5669), __webpack_require__.e(2078), __webpack_require__.e(9734), __webpack_require__.e(7255), __webpack_require__.e(3973), __webpack_require__.e(310), __webpack_require__.e(1962), __webpack_require__.e(9381)]).then(__webpack_require__.bind(__webpack_require__, 69190)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(69190)]
  }
});

const ShopDetail = props => {
  return (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Mobile, _objectSpread({}, props)) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(PC, _objectSpread({}, props));
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopDetail);

/***/ }),

/***/ 97588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1405);



const useIsMobile = () => {
  var _window;

  const {
    isMobile
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state => state.ssr);

  if (!_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF && (_window = window) !== null && _window !== void 0 && _window.navigator.userAgent) {
    var _window2;

    return (0,_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isMobile */ .tq)((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.navigator.userAgent);
  }

  return isMobile;
};

/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);

/***/ }),

/***/ 26310:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[id]/[[...name]]",
      function () {
        return __webpack_require__(49715);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3220,455,8940,3954,4730,9612,7530,4367,9669,4607,8097,8126,6864,1723,641,7716,6337,9195,1349,1771,5434,3242,7931,1926,4452,5417,6351,1120,5871,236,6611,3097,1954,4347,7634,9509,5287,9,336,9843,8594,1258,5280,7401,7971,3457,1738,6859,9161,6158,4071,3066], function() { return __webpack_exec__(26310); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);